import {
  greenWallet,
  orangeCoin,
  orangeGrowth,
  purpleGrowth,
} from "@/common/components/icons/svg-icons";

export const secretariatCards = [
  {
    id: 1,
    name: "Total DRF user",
    value: 50,
    icon: greenWallet,
    color: "#43A047",
  },
  {
    id: 2,
    name: "Revenue Fund Allocation",
    value: "500,000",
    icon: orangeCoin,
    color: "#FF9800",
  },
  {
    id: 3,
    name: "Total Fund Release",
    value: "100,000",
    icon: purpleGrowth,
    color: "#673AB7",
  },
  {
    id: 4,
    name: "Current DRF Balance",
    value: "1,000,000",
    icon: orangeGrowth,
    color: "#FF5722",
  },
];

export const fundAllocationCards = [
  {
    id: 1,
    name: "Current DRF Balance",
    value: "50,000",
    icon: greenWallet,
    color: "#43A047",
  },
  {
    id: 2,
    name: "Total Sales Revenue",
    value: "500,000",
    icon: orangeCoin,
    color: "#FF9800",
  },
  {
    id: 3,
    name: "Total Expired Drugs",
    value: "100,000",
    icon: purpleGrowth,
    color: "#673AB7",
  },
  {
    id: 4,
    name: "Low Stock",
    value: "1",
    icon: orangeGrowth,
    color: "#FF5722",
  },
];

export const financialManagementCards = [
  {
    id: 1,
    name: "Starting Balance",
    value: "50,000",
    icon: greenWallet,
    color: "#43A047",
  },
  {
    id: 2,
    name: "Revenue Generated",
    value: "500,000",
    icon: orangeCoin,
    color: "#FF9800",
  },
  {
    id: 3,
    name: "Fund Allocated",
    value: "100,000",
    icon: purpleGrowth,
    color: "#673AB7",
  },
  {
    id: 4,
    name: "Current DRF Balance",
    value: "1",
    icon: orangeGrowth,
    color: "#FF5722",
  },
];

export const facilityTableHeaders = [
  "Facility Name",
  "Current Balance",
  "Last Allocation Date",
  "DRF Request Balance",
];

export const facilityTableKeys = [
  "facility_name",
  "current_balance",
  "last_allocation",
  "request_status",
];

export const getFacilityTableData = (_: any) => [
  {
    id: "1",
    facility_name: { value: "Lagos General Hospital", type: "string" },
    current_balance: { value: "25000", type: "string" },
    last_allocation: { value: "2025-06-15", type: "string" },
    request_status: { value: "approved", type: "string" },
  },
  {
    id: "2",
    facility_name: { value: "Abuja Specialist Clinic", type: "string" },
    current_balance: { value: "17800", type: "string" },
    last_allocation: { value: "2025-06-20", type: "string" },
    request_status: { value: "pending", type: "string" },
  },
  {
    id: "3",
    facility_name: { value: "Enugu Health Center", type: "string" },
    current_balance: { value: "9500", type: "string" },
    last_allocation: { value: "2025-07-05", type: "string" },
    request_status: { value: "rejected", type: "string" },
  },
  {
    id: "4",
    facility_name: { value: "Port Harcourt Medical Center", type: "string" },
    current_balance: { value: "30400", type: "string" },
    last_allocation: { value: "2025-07-01", type: "string" },
    request_status: { value: "approved", type: "string" },
  },
  {
    id: "5",
    facility_name: { value: "Kano General Hospital", type: "string" },
    current_balance: { value: "21000", type: "string" },
    last_allocation: { value: "2025-06-28", type: "string" },
    request_status: { value: "pending", type: "string" },
  },
  {
    id: "6",
    facility_name: { value: "Ibadan Specialist Hospital", type: "string" },
    current_balance: { value: "12000", type: "string" },
    last_allocation: { value: "2025-07-03", type: "string" },
    request_status: { value: "approved", type: "string" },
  },
  {
    id: "7",
    facility_name: { value: "Kaduna Central Hospital", type: "string" },
    current_balance: { value: "8600", type: "string" },
    last_allocation: { value: "2025-06-25", type: "string" },
    request_status: { value: "rejected", type: "string" },
  },
  {
    id: "8",
    facility_name: { value: "Benin City Health Hub", type: "string" },
    current_balance: { value: "15700", type: "string" },
    last_allocation: { value: "2025-07-04", type: "string" },
    request_status: { value: "pending", type: "string" },
  },
  {
    id: "9",
    facility_name: { value: "Maiduguri Care Center", type: "string" },
    current_balance: { value: "19400", type: "string" },
    last_allocation: { value: "2025-06-30", type: "string" },
    request_status: { value: "approved", type: "string" },
  },
  {
    id: "10",
    facility_name: {
      value: "Jos University Teaching Hospital",
      type: "string",
    },
    current_balance: { value: "22450", type: "string" },
    last_allocation: { value: "2025-07-02", type: "string" },
    request_status: { value: "pending", type: "string" },
  },
];

export const fundAllocationTableHeaders = [
  "Request Date",
  "Submitted By",
  "Amount Requested",
  "Status",
];

export const fundAllocationTableKeys = [
  "request_date",
  "submitted_by",
  "amount_requested",
  "status",
];

export const getFundAllocationTableData = (_: any) => [
  {
    id: "1",
    request_date: { value: "2025-07-01", type: "string" },
    submitted_by: { value: "Dr. Jane Doe", type: "string" },
    amount_requested: { value: "12000", type: "string" },
    status: { value: "approved", type: "string" },
  },
  {
    id: "2",
    request_date: { value: "2025-06-28", type: "string" },
    submitted_by: { value: "Mr. John Smith", type: "string" },
    amount_requested: { value: "7500", type: "string" },
    status: { value: "pending", type: "string" },
  },
  {
    id: "3",
    request_date: { value: "2025-06-25", type: "string" },
    submitted_by: { value: "Mrs. Grace Nwosu", type: "string" },
    amount_requested: { value: "9800", type: "string" },
    status: { value: "rejected", type: "string" },
  },
  {
    id: "4",
    request_date: { value: "2025-07-03", type: "string" },
    submitted_by: { value: "Dr. Aliyu Bello", type: "string" },
    amount_requested: { value: "15000", type: "string" },
    status: { value: "approved", type: "string" },
  },
  {
    id: "5",
    request_date: { value: "2025-07-02", type: "string" },
    submitted_by: { value: "Nurse Rita Okafor", type: "string" },
    amount_requested: { value: "4200", type: "string" },
    status: { value: "pending", type: "string" },
  },
  {
    id: "6",
    request_date: { value: "2025-06-30", type: "string" },
    submitted_by: { value: "Dr. Emeka Chukwu", type: "string" },
    amount_requested: { value: "20000", type: "string" },
    status: { value: "approved", type: "string" },
  },
  {
    id: "7",
    request_date: { value: "2025-06-29", type: "string" },
    submitted_by: { value: "Mr. Tunde Ayeni", type: "string" },
    amount_requested: { value: "6000", type: "string" },
    status: { value: "rejected", type: "string" },
  },
  {
    id: "8",
    request_date: { value: "2025-06-27", type: "string" },
    submitted_by: { value: "Mrs. Bola Akin", type: "string" },
    amount_requested: { value: "13500", type: "string" },
    status: { value: "pending", type: "string" },
  },
  {
    id: "9",
    request_date: { value: "2025-06-26", type: "string" },
    submitted_by: { value: "Dr. Miriam Okon", type: "string" },
    amount_requested: { value: "15800", type: "string" },
    status: { value: "approved", type: "string" },
  },
  {
    id: "10",
    request_date: { value: "2025-06-24", type: "string" },
    submitted_by: { value: "Mr. Uche Eze", type: "string" },
    amount_requested: { value: "8900", type: "string" },
    status: { value: "pending", type: "string" },
  },
];

export const secretariatFacilityTableHeaders = [
  "Facility Name",
  "Current Balance",
  "Last Allocation date",
  "DRF Request Status",
];

export const secretariatFacilityTableKeys = [
  "facility_name",
  "current_balance",
  "last_allocation",
  "request_status",
];

export const getSecretariatFacilityTableData = (_: any) => [
  {
    id: "1",
    facility_name: { value: "Lagos General Hospital", type: "string" },
    current_balance: { value: "25000", type: "string" },
    last_allocation: { value: "2025-06-15", type: "string" },
    request_status: { value: "approved", type: "string" },
  },
  {
    id: "2",
    facility_name: { value: "Abuja Specialist Clinic", type: "string" },
    current_balance: { value: "17800", type: "string" },
    last_allocation: { value: "2025-06-20", type: "string" },
    request_status: { value: "pending", type: "string" },
  },
  {
    id: "3",
    facility_name: { value: "Enugu Health Center", type: "string" },
    current_balance: { value: "9500", type: "string" },
    last_allocation: { value: "2025-07-05", type: "string" },
    request_status: { value: "rejected", type: "string" },
  },
  {
    id: "4",
    facility_name: { value: "Port Harcourt Medical Center", type: "string" },
    current_balance: { value: "30400", type: "string" },
    last_allocation: { value: "2025-07-01", type: "string" },
    request_status: { value: "approved", type: "string" },
  },
  {
    id: "5",
    facility_name: { value: "Kano General Hospital", type: "string" },
    current_balance: { value: "21000", type: "string" },
    last_allocation: { value: "2025-06-28", type: "string" },
    request_status: { value: "pending", type: "string" },
  },
  {
    id: "6",
    facility_name: { value: "Ibadan Specialist Hospital", type: "string" },
    current_balance: { value: "12000", type: "string" },
    last_allocation: { value: "2025-07-03", type: "string" },
    request_status: { value: "approved", type: "string" },
  },
  {
    id: "7",
    facility_name: { value: "Kaduna Central Hospital", type: "string" },
    current_balance: { value: "8600", type: "string" },
    last_allocation: { value: "2025-06-25", type: "string" },
    request_status: { value: "rejected", type: "string" },
  },
  {
    id: "8",
    facility_name: { value: "Benin City Health Hub", type: "string" },
    current_balance: { value: "15700", type: "string" },
    last_allocation: { value: "2025-07-04", type: "string" },
    request_status: { value: "pending", type: "string" },
  },
  {
    id: "9",
    facility_name: { value: "Maiduguri Care Center", type: "string" },
    current_balance: { value: "19400", type: "string" },
    last_allocation: { value: "2025-06-30", type: "string" },
    request_status: { value: "approved", type: "string" },
  },
  {
    id: "10",
    facility_name: {
      value: "Jos University Teaching Hospital",
      type: "string",
    },
    current_balance: { value: "22450", type: "string" },
    last_allocation: { value: "2025-07-02", type: "string" },
    request_status: { value: "pending", type: "string" },
  },
];

export const getFacilityDetails = () => {
  return {
    id: 1,
    name: "Bingham Teaching Hos[ital",
    current_balance: "10,000",
    last_allocation_date: "2025-07-02",
    last_allocation: "50,000",
    current_request: "100,000",
  };
};

export const FacilityDetailsTableHeaders = [
  "Month",
  "Sales Revenue",
  "Restocking Cost",
  "Net Balance",
];

export const FacilityDetailsTableKeys = [
  "month",
  "sales_balance",
  "restocking_cost",
  "net_balance",
];

export const getFacilityDetailsTableData = (data: any) => [
  {
    id: "1",
    month: { value: "January", type: "string" },
    sales_revenue: { value: "1050000", type: "string" },
    restocking_cost: { value: "600000", type: "string" },
    net_balance: { value: "450000", type: "string" },
    data: data, // this will be remove during api integration
  },
  {
    id: "2",
    month: { value: "February", type: "string" },
    sales_revenue: { value: "912000", type: "string" },
    restocking_cost: { value: "550000", type: "string" },
    net_balance: { value: "362000", type: "string" },
  },
  {
    id: "3",
    month: { value: "March", type: "string" },
    sales_revenue: { value: "1300000", type: "string" },
    restocking_cost: { value: "700000", type: "string" },
    net_balance: { value: "600000", type: "string" },
  },
  {
    id: "4",
    month: { value: "April", type: "string" },
    sales_revenue: { value: "1196000", type: "string" },
    restocking_cost: { value: "650000", type: "string" },
    net_balance: { value: "546000", type: "string" },
  },
  {
    id: "5",
    month: { value: "May", type: "string" },
    sales_revenue: { value: "975000", type: "string" },
    restocking_cost: { value: "510000", type: "string" },
    net_balance: { value: "465000", type: "string" },
  },
  {
    id: "6",
    month: { value: "June", type: "string" },
    sales_revenue: { value: "1248000", type: "string" },
    restocking_cost: { value: "590000", type: "string" },
    net_balance: { value: "658000", type: "string" },
  },
  {
    id: "7",
    month: { value: "July", type: "string" },
    sales_revenue: { value: "1378000", type: "string" },
    restocking_cost: { value: "640000", type: "string" },
    net_balance: { value: "738000", type: "string" },
  },
  {
    id: "8",
    month: { value: "August", type: "string" },
    sales_revenue: { value: "1107000", type: "string" },
    restocking_cost: { value: "580000", type: "string" },
    net_balance: { value: "527000", type: "string" },
  },
  {
    id: "9",
    month: { value: "September", type: "string" },
    sales_revenue: { value: "1222000", type: "string" },
    restocking_cost: { value: "600000", type: "string" },
    net_balance: { value: "622000", type: "string" },
  },
  {
    id: "10",
    month: { value: "October", type: "string" },
    sales_revenue: { value: "1170000", type: "string" },
    restocking_cost: { value: "620000", type: "string" },
    net_balance: { value: "550000", type: "string" },
  },
];

export const newFundRequestForm = [
  {
    inputType: "selectInput",
    name: "request_hospital",
    prompt: "Requesting Hospital",
    rules: { required: true },
    placeholder: "Enter Hospital Name",
    options_name: "hospital_status",
    options: [
      { id: "1", title: "Ota General Hospital" },
      { id: "2", title: "Convenant University Teaching Hospital" },
      { id: "3", title: "Ariset Hospital" },
    ],
    isFullWidth: true,
    required: true,
  },
  {
    inputType: "text",
    name: "request_amount",
    prompt: " Request Amount",
    placeholder: "Enter Request Amount",
    required: true,
    isFullWidth: false,
  },
  {
    inputType: "selectInput",
    name: "purpose_category",
    prompt: "Purpose Category",
    rules: { required: true },
    placeholder: "Enter Purpose of Request",
    options_name: "request_purpose",
    options: [
      { id: "1", title: "Drug Purchase" },
      { id: "2", title: "Fund Depletion" },
      { id: "3", title: "Others" },
    ],
    isFullWidth: false,
    required: true,
  },
  {
    inputType: "date",
    prompt: "Expected Disbursement Date",
    name: "expected_disbursement_date",
    placeholder: "Enter expected disbursement date",
    fullWidth: false,
    rules: {
      notInTheFuture: {
        expectedValue: false,
        errorMessage: "Your disbursement date cannot be in the past",
      },
    },
  },
  {
    name: "justification",
    prompt: "Justification",
    placeholder: "Justification",
    isFullWidth: false,
    shortWidth: false,
    inputtype: "textarea",
  },
];

export const batchAllocationTableHeaders = [
  "S/N",
  "Facility Name",
  "Amount",
  "Justification",
  "purpose(optional)",
];

export const batchAllocationTableKeys = [
  "serial",
  "facility_name",
  "amount",
  "justification",
  "purpose",
];

export const getBatchAllocationTabledata = (data: any) => {
  return data;
};

export const downloadCSVTemplate = () => {
  const headers = [
    "S/N",
    "Facility Name",
    "Amount",
    "Justification",
    "Purpose(optional)",
  ];
  const csvContent = [headers].map((e) => e.join(",")).join("\n");

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "batch_allocation_template.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
